import {CLEAR_ASSIGN_TABLE} from '../_CONSTANTS';

export const clear_Assign_Table = () => {
  return ({
    type: CLEAR_ASSIGN_TABLE,
    payload: {}
  })
}
